import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

export const ReportTemplateFormRow = styled.div<{
  noBorder?: boolean;
  initialColumnWidth?: string;
}>`
  display: grid;
  grid-template-columns: ${({ initialColumnWidth }) => initialColumnWidth ?? '50%'} auto;
  align-items: center;
  border-bottom: ${({ noBorder, theme }) =>
    noBorder ? 'initial' : `1px solid ${theme.color.border.secondary}`};
  padding: ${Spacing[4]} 0;
`;

export const ReportTemplateFormRowLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReportTemplateFormRowField = styled.div<{ flex?: boolean; width?: string }>`
  display: ${({ flex }) => (flex ? 'flex' : 'inline-block')};
  align-items: center;
  margin-left: auto;
  width: ${({ width }) => width ?? 'auto'};

  & > div {
    margin-bottom: 0;
  }
`;
